import { Injectable } from "@angular/core";
import { GenericServicesMotoristaService } from "./generic-services-motorista.service";
import { MensagensService } from "max-ng-lib";
import { HttpClient } from "@angular/common/http";

@Injectable({
	providedIn: "root",
})
export class RotaService extends GenericServicesMotoristaService {
	constructor(
		private mensagensService: MensagensService,
		private httpClient: HttpClient
	) {
		super();
	}

	getMensagensService(): MensagensService {
		return this.mensagensService;
	}

	getHttpClient(): HttpClient {
		return this.httpClient;
	}

	getUrlRecurso(): string {
		return "/rota";
	}

	listar() {
		return this.get("/listar", {
			dados: {
				exibirLoading: true,
			},
		});
	}
}
